import React from 'react';
import iconNs from '@ant-design/icons';

const Icon = iconNs.default || iconNs;

export function PdfIconComponent() {
  return (
    <svg width="1em" height="1em" viewBox="0 0 1000 1000" style={{ enableBackground: 'new 0 0 1000 1000' }} role="img" >
      <path d="M845.4 296.9 654.9 98c-2.9-3-7-4.8-11.2-4.8H307.6c-44.5 0-80.7 36.2-80.7 80.7v365.9c0 8.6 7 15.5 15.5 15.5 8.6 0 15.5-7 15.5-15.5V173.9c0-27.4 22.3-49.7 49.7-49.7h309.3v129c0 45.4 37 82.4 82.4 82.4h119.4V826c0 27.4-22.3 49.7-49.7 49.7H341.8c-8.6 0-15.5 7-15.5 15.5 0 8.6 7 15.5 15.5 15.5H769c44.5 0 80.7-36.2 80.7-80.7V307.6c.1-4-1.5-7.8-4.3-10.7zm-197.5-43.6V135.6l162 169.1H699.3c-28.3-.1-51.4-23.1-51.4-51.4z" style={{ fill: 'currentColor' }} />
      <path d="M228.2 616.8h-58.6c-12.2 0-19.1 9.4-19.3 20.7v152.3c0 9.9 9.7 18.8 20.2 18.8 11.1 0 20.2-8.6 20.2-18.8v-48.4h37.6c43.4 0 62.7-30.7 62.7-62.2-.1-31.1-19.4-62.4-62.8-62.4zm-2 89.3h-35.6v-53.6h36.8c15.2 0 22.9 14.9 22.9 26.8 0 12.4-8.3 26.8-24.1 26.8zm182.6 101.1c54.7 0 86-40.9 86-94.8 0-54.2-31.2-95.6-86-95.6h-58.6c-10.2 0-15.8 7.7-16 17.1V790c0 9.1 5.8 17.1 16 17.1h58.6zm-34.2-154.7h34.3c30.4 0 45.6 28.5 45.6 60 0 31.2-15.2 59.4-45.6 59.4h-34.3V652.5zm271.6 0c8.8-.3 16.6-8.6 16.6-17.7 0-9.9-7.5-18-16.6-18h-87.6c-10.2 0-15.8 7.7-16 17.1v155.9c0 9.9 9.7 18.8 20.2 18.8 11.1 0 20.2-8.6 20.2-18.8V731h47c8.9 0 16.6-8.3 16.6-17.4 0-9.7-7.5-17.4-16.6-17.4h-47v-43.7h63.2z" style={{ fill: 'currentColor' }} />
    </svg>
  );
}

function PdfIcon() {
  return (
    <Icon component={PdfIconComponent} />
  );
}

export default PdfIcon;
